import type { ApiClient } from '../client';

// Force a «Entrega» to non_retrieved (the courier opened the «buzón» to retrieve the parcel and
// found it empty). The id rides the path (url-encoded); the client attaches the Firebase token via
// the Authorization header — no body, so nothing else can reach a request log on this route. Empty
// 200 — nothing to parse; the caller refetches the detail to surface the new state and the
// «Recuperación vacía» row.
export async function nonRetrieveDelivery(client: ApiClient, id: string): Promise<void> {
  await client.post(`/app_service/panel/v1/deliveries/${encodeURIComponent(id)}/non-retrieve`);
}
